/**
 * Where the others sit around the player, who is at the bottom of the screen. The game turns
 * clockwise (owner's rule, October 2026): the next seat (+1 in the server's order of players, which is
 * the order the waiting room was filled in, backend advance_turn) plays after the player, so it sits on
 * their left; then the seat facing them; then the one on their right, who plays just before them.
 *
 * The others used to be shown in the server's order, the player's own seat left out: right for the
 * player of the first seat only. Everyone else saw the turn jump about the table, skip a player or go
 * backwards (owner's report).
 */

/**
 * The other seats from the player's left, in the order of play: `list[(me + 1) % total]`, … A seat with
 * nobody yet is null (a waiting room: the next to come takes the next seat). Without the player in the
 * list, the others as they are.
 */
export function seatsFrom(list, myId, total = list.length) {
  const me = list.findIndex((p) => p.user_id === myId);
  if (me < 0) {
    const others = list.filter((p) => p.user_id !== myId);
    return Array.from({ length: Math.max(0, total - 1) }, (_, k) => others[k] ?? null);
  }
  return Array.from({ length: Math.max(0, total - 1) }, (_, k) => list[(me + 1 + k) % total] ?? null);
}
